import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    category: 'Response Time',
    manual: '3-6 hours (or never)',
    viridia: '8 seconds, every time'
  }, {
    category: 'Availability',
    manual: 'Business hours only',
    viridia: '24/7, even at 2am'
  }, {
    category: 'Lead Conversion',
    manual: '30-40% (slow replies lose jobs)',
    viridia: '80-90% (instant booking)'
  }, {
    category: 'Follow-up',
    manual: 'Manual tracking, easy to forget',
    viridia: 'Automatic reminders & tracking'
  }, {
    category: 'Time Investment',
    manual: '2-3 hours/day managing leads',
    viridia: '0 hours - fully automated'
  }, {
    category: 'Booking Process',
    manual: 'Back-and-forth messages',
    viridia: 'Direct to calendar in one step'
  }];
  return <section className="py-20 px-6 bg-[var(--white-smoke)]" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-71">
          <h2 className="text-4xl md:text-5xl font-bold text-[var(--jet-black)] mb-4" data-id="element-72">
            Manual vs With Viridia
          </h2>
          <p className="text-xl text-[var(--graphite-gray)]" data-id="element-73">
            See the difference automation makes
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-74">
          <div className="grid grid-cols-3 bg-[var(--jet-black)] text-white p-4" data-id="element-75">
            <div className="font-bold text-lg" data-id="element-76"></div>
            <div className="font-bold text-lg text-center" data-id="element-77">Manual</div>
            <div className="font-bold text-lg text-center text-[var(--viridia-green)]" data-id="element-78">
              With Viridia
            </div>
          </div>

          {comparisons.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className={`grid grid-cols-3 p-4 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`} data-id="element-79">
              <div className="font-semibold text-[var(--jet-black)] pr-4" data-id="element-80">
                {item.category}
              </div>
              <div className="text-center text-[var(--graphite-gray)] flex items-center justify-center gap-2" data-id="element-81">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-82" />
                <span className="text-sm" data-id="element-83">{item.manual}</span>
              </div>
              <div className="text-center text-[var(--jet-black)] flex items-center justify-center gap-2" data-id="element-84">
                <CheckIcon className="w-4 h-4 text-[var(--viridia-green)] flex-shrink-0" data-id="element-85" />
                <span className="text-sm font-semibold" data-id="element-86">{item.viridia}</span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}